import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Card, Form, Spinner } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { loaFormData } from './loaformdata.js';
import axios from 'helpers/api';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';
import { hcpRoutes } from 'routes/siteMaps.js';
import { useParams } from 'react-router-dom';



const LoaFormGrid = ({ childTableData, data }) => {
  const columns = [
    {
      accessorKey: 'medication',
      header: 'Medication',
      meta: {
        headerProps: {
          className: 'text-start text-900'
        },
        cellProps: {
          className: 'text-start'
        }
      }
    },
    {
      accessorKey: 'strength',
      header: 'Strength',
      meta: {
        headerProps: {
          className: 'text-end text-900'
        },
        cellProps: {
          className: 'text-end'
        }
      }
    },
    {
      accessorKey: 'amount',
      header: 'Amount',
      meta: {
        headerProps: {
          className: 'text-end text-900'
        },
        cellProps: {
          className: 'text-end'
        }
      }
    },
    {
      accessorKey: 'frequency',
      header: 'Frequency',
      meta: {
        headerProps: {
          className: 'text-end text-900'
        },
        cellProps: {
          className: 'text-end'
        }
      }
    },
    {
      accessorKey: 'quantity',
      header: 'Quantity',
      cell: ({ row }) => {
        const id = row.original.pharmacy_order_id;
    
        return (
          <Form.Control
            type="text"
            placeholder="0.0"
            className="text-end"
            defaultValue={quantityRef.current[id]}
            onChange={(e) => {
              quantityRef.current[id] = e.target.value;
            }}
          />
        );
      }
    }
    
  ];
  const [iframeSrc, setIframeSrc] = useState(null);
  const { programId } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const quantityRef = useRef({});
  const [tableData, setTableData] = useState([]);
  const table = useAdvanceTable({
    data: tableData,
    columns,
    selection: false,
    sortable: true,
    pagination: true
  });

  useEffect(() => { fetchData() }, [data]);


  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
  
    const FinalPayload = {
      patient_id : childTableData.patient_id,
      departure_datetime : childTableData.departure_datetime,
      return_datetime : childTableData.return_datetime,
      hcp_order_format : childTableData.hcp_order_format,
      quantities: {},
      designation : childTableData.designation,
      hcp_id : childTableData.hcp_id,
    }

    if (programId) {
      FinalPayload.day_program_id = programId;
    }
    Object.keys(quantityRef.current).forEach(id => {
      FinalPayload.quantities[id] = quantityRef.current[id];
    });

    let tokenStr = localStorage.getItem("accessToken");
    let pelmedsMedSheetUrl = `${process.env.REACT_APP_SERVER_URL}/reports/loa-report`
    try {
      const response = await axios.post(pelmedsMedSheetUrl, FinalPayload, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
      if (!(response.data.status)) {
        setError(response.data.message);
      }
      const { blobUrl } = await createIframeReportBlobUrl(response.data);
      setIframeSrc(blobUrl);
    } catch (err) {
      setError("Failed to print content.");
    } finally {
      setLoading(false);
    }
  };
  

  const fetchData = async () => {
    const tokenStr = localStorage.getItem('accessToken');
    let frequencyMap = {};
    let amountMap = [];
    const getAllItems = {
      amount: {},
      frequency: {}
    };
    await axios.post(`${process.env.REACT_APP_SERVER_URL}/prescriptions/fetch-multiple`, getAllItems, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
      .then((res) => {
        let objFreqData = res.data.output.data["frequency"];
        let objAmountData = res.data.output.data["amount"];
        frequencyMap = objFreqData.reduce((acc, item) => {
          acc[item.id] = item.name;
          return acc;
        }, {});
        amountMap = objAmountData.reduce((acc, item) => {
          acc[item.id] = item.amount;
          return acc;
        }, {});
      })


    let results = [];
    data.forEach((item) => {
      const id = item.id;
      quantityRef.current[id] = item.no_of_pills?.toString() || '';
    
      results.push({
        pharmacy_order_id: id,
        medication: item.drug,
        strength: item.dose,
        amount: amountMap[item.amount_id],
        frequency: frequencyMap[item.frequency_id],
        quantity: quantityRef.current[id]
      });
    });
    setTableData(results);
  }

  return (
    <>
      <div style={{
        height: 0,
        overflow: 'hidden',
        // width: 0
      }}>
        {iframeSrc && (
          <iframe
            src={iframeSrc}
            style={{ width: "100%", height: "500px", border: "none" }}
            title="Preview Content"
          />
        )}
      </div>
      {tableData.length > 0 ? <AdvanceTableProvider {...table}>
        <Card className="h-100">
          <Card.Body className="px-0 pt-0">
            <AdvanceTable
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                className: 'fs-10 mb-0 overflow-hidden'
              }}
            />
            <div className="text-end px-3 mt-3">
              {!loading ? <Button className="btn btn-primary btn-sm" onClick={handleSave}>
                Generate
              </Button> : <Spinner animation="border" role="status" size="sm"></Spinner>}
            </div>
          </Card.Body>
        </Card>
      </AdvanceTableProvider> : <Alert variant="info" className="text-center fw-bold">
        No data found.
      </Alert>}
    </>
  );
};

/*LoaFormGrid.propTypes = {
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      path: PropTypes.string.isRequired,
      views: PropTypes.number.isRequired,
      time: PropTypes.string.isRequired,
      exitRate: PropTypes.string.isRequired
    })
  ).isRequired,
  perPage: PropTypes.number
};*/

export default LoaFormGrid;

